import SiteHeader from '@/pages/home/components/SiteHeader';
import Hero from '@/pages/home/components/Hero';
import TodayMelons from '@/pages/home/components/TodayMelons';
import TopicWall from '@/pages/home/components/TopicWall';
import FreshLeaks from '@/pages/home/components/FreshLeaks';
import LatestGossip from '@/pages/home/components/LatestGossip';
import RankBoard from '@/pages/home/components/RankBoard';
import JoinCta from '@/pages/home/components/JoinCta';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <TodayMelons />
        <TopicWall />
        <FreshLeaks />
        <LatestGossip />
        <RankBoard />
        <JoinCta />
      </main>
      <Footer />
    </div>
  );
}